import { IFeature, PaymentMessage } from '.';

export interface PaymentMessageFeature extends IFeature {
    messages?: PaymentMessage[];
}
